import { useViewport } from 'contexts/viewport';
import { PageContext } from 'pages/Preview/PageProvider';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dropdown, Icon, Stack, styled, Text } from 'shell/components';

const Header = () => {
    const { t } = useTranslation();
    const { device } = useViewport();

    const {
        previewSubmissions,
        currentSubmission,
        isGradesGenerating,
        isFeedbackGenerating,
        handleClickNext,
        handleSelectSubmission,
    } = useContext(PageContext);

    const isGenerating = isGradesGenerating || isFeedbackGenerating;

    const currentFile = currentSubmission.files[0];

    const SubmissionTitle = (
        <Text component={'h1'} noWrap title={currentFile.name} variant={'p1'}>
            {currentFile.original_file ? currentFile.original_file.name : currentFile.name}
        </Text>
    );

    const SubmissionTimestamp = (
        <Text color={'light'} variant={'p3'}>
            {t('ui.uploaded', 'Uploaded')}: {t('ui.format-date-short', { val: currentSubmission.created_on })}
        </Text>
    );

    const NextButton = (
        <Button
            disabled={isGenerating || previewSubmissions.length === 1}
            variant={'tertiary'}
            onClick={handleClickNext}
        >
            {t('controls.next', 'Next')}
        </Button>
    );

    const NavigationDropdown = (
        <Stack alignItems={'center'} direction={'row'} spacing={2}>
            <Text weight={'semibold'}>{t('ui.progress', 'Progress')}</Text>
            <Dropdown
                id={'preview-select-submission-dropdown'}
                options={previewSubmissions.map(({ id, files }, index) => {
                    const currentFile = files[0];
                    const submissionName = currentFile.original_file
                        ? currentFile.original_file.name
                        : currentFile.name;
                    return {
                        key: id,
                        value: `${index + 1}. ${submissionName}`,
                    };
                })}
                rootComponent={
                    <Button
                        sx={{ mt: -1 }}
                        color={'neutral'}
                        disabled={isGenerating}
                        endIcon={<Icon kind={'dropdownArrowDown'} />}
                        variant={'borderless'}
                    >
                        {previewSubmissions.findIndex(({ id }) => id === currentSubmission.id) + 1}/
                        {previewSubmissions.length}
                    </Button>
                }
                onSelect={({ key: submissionId }) => handleSelectSubmission(submissionId)}
            />
        </Stack>
    );

    return device === 'mobile' ? (
        <RootStack device={device} justifyContent={'space-between'}>
            <Stack spacing={1}>
                {SubmissionTitle}
                {SubmissionTimestamp}
            </Stack>
            <Stack alignItems={'center'} direction={'row'} justifyContent={'space-between'}>
                {NavigationDropdown}
                {NextButton}
            </Stack>
        </RootStack>
    ) : (
        <RootStack alignItems={'center'} device={device} direction={'row'} justifyContent={'space-between'} spacing={4}>
            <Stack sx={{ flex: 1, minWidth: 0 }} spacing={1}>
                {SubmissionTitle}
                {SubmissionTimestamp}
            </Stack>
            <Stack alignItems={'center'} direction={'row'} spacing={4}>
                {NavigationDropdown}
                {NextButton}
            </Stack>
        </RootStack>
    );
};

const RootStack = styled(Stack)(({ theme, device }) => {
    return {
        borderBottom: `1px solid ${theme.palette.ensightful.neutral[300]}`,
        width: '100%',
        height: device === 'mobile' ? '109px' : '65px',
        padding: device === 'mobile' ? theme.spacing(3, 4) : theme.spacing(3, 5),
        background: theme.palette.ensightful.primary[50],
    };
});

export default Header;
